import Typography from '@mui/material/Typography';
import { Box, IconButton, Modal } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { PromptLibraryCategory } from './PromptLibraryCategory';
import { Prompt } from './Prompt';
import { useState } from 'react';
import { useAppSelector } from '../../../../store/hooks';
import { PromptLibraryItem } from '../../../../store/one-query/promptLibrarySlice';
import { PromptLibraryLIcon } from '../../../../Custom-imeges/Prompt-library-icons/PromptLibraryLIcon';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import "./PromptLibrary.css"

interface PromptLibraryProps {
  handleClose : () => void;
  setLibraryPrompt: (prompt:string) => void;
  open:boolean;
}

export const PromptLibrary = ({handleClose,open,setLibraryPrompt}:PromptLibraryProps) => {
  const [expandedPanel, setExpandedPanel] = useState<string | false>(false);
  const promptLibrary = useAppSelector((s) => s.PromptLibrary.promptLibraryItems);
  const [promptContent,setPromptContent] = useState<PromptLibraryItem[]>([])
  const [activeSubtype,setActiveSubtype] = useState("");
  const User = useAppSelector((s) => s.User);

  // Remove duplicates types.
  const promptTitles = promptLibrary
  ? Array.from(new Map(promptLibrary.map((prompt) => [prompt.type, prompt])).values())
  : [];

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="prompt-library-modal" sx={{outline:'none'}}>
          <Box className="prompt-library-modal-header">
            <Box sx={{display:'flex',alignItems:'center',gap:'8px'}} onClick={() => setActiveSubtype('')}>
              <Box className={`prompt-lib-back-arrow ${activeSubtype.length > 0 && 'active'}`}>
                <KeyboardBackspaceIcon fontSize="medium"/>
              </Box>
              <Typography>Prompts</Typography>
            </Box>
            <IconButton onClick={handleClose}>
              <ClearIcon sx={{color: User.darkMode ? '#fff' : '#0B1216'}} fontSize="medium" />
            </IconButton>
          </Box>
         <Box className="prompt-library-modal-body">
                      <Box className={`prompt-library-modal-sidebar ${activeSubtype.length > 0 && 'non-active'}`} sx={{ px: "0" }}>
              {promptTitles.map((prompt:PromptLibraryItem) => (
                  <PromptLibraryCategory key={prompt.id} prompt={prompt} panelId={prompt.id} expandedPanel={expandedPanel}
                  setExpandedPanel={setExpandedPanel} setPromptContent={setPromptContent} setActiveSubtype={setActiveSubtype} activeSubtype={activeSubtype}/>
              ))}
            </Box>
            <Box className={`prompt-library-modal-content ${activeSubtype.length > 0 && 'active'}`}>
              {
                promptContent.length > 0 ? (
                  <Box>
                    {promptContent.map((pro) => (
                      <Prompt key={pro.id} prompt={pro}setLibraryPrompt={setLibraryPrompt}/>
                    ))}
                  </Box>
                ) : 
                (
                  <Box className="prompt-library-msg">
                  <PromptLibraryLIcon/>
                  <Typography className='prompt-library-msg-title'>Select a prompt</Typography>
                  <Typography className='prompt-library-msg-desc'>Explore a curated library of prompts and choose the one that best fits your needs.</Typography>
                  </Box>
                )
              }
            </Box>
         </Box>
        </Box>
      </Modal>
    </div>
  );
}